export const EMBED_INTEGRATION_TYPE = {
  DEFAULT: 'DEFAULT',
  HQO: 'HQO',
};
